import { Button } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export type SubmitButtonProps = {
  text?: string;
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  form?: string;
};

export const SubmitButton: FC<SubmitButtonProps> = ({
  text,
  onClick,
  loading,
  disabled,
  form,
}) => {
  const { t } = useTranslation();
  return (
    <Button
      form={form}
      loading={loading}
      type="primary"
      htmlType="submit"
      onClick={onClick}
      disabled={disabled}
    >
      {text ?? t('save')}
    </Button>
  );
};
